export const GET_COUNTERPARTIES = 'GET_COUNTERPARTIES';
export const COUNTERPARTIES_RECEIVED = 'COUNTERPARTIES_RECEIVED';

export const CREATE_COUNTERPARTY = 'CREATE_COUNTERPARTY';
export const UPDATE_COUNTERPARTY = 'UPDATE_COUNTERPARTY';
export const DELETE_COUNTERPARTY = 'DELETE_COUNTERPARTY';
export const CREATE_COUNTERPARTY_RECEIVED = 'CREATE_COUNTERPARTY_RECEIVED';
export const UPDATE_COUNTERPARTY_RECEIVED = 'UPDATE_COUNTERPARTY_RECEIVED';
export const DELETE_COUNTERPARTY_RECEIVED = 'DELETE_COUNTERPARTY_RECEIVED';
